import { Tooltip } from '../../../common/components/tooltip';
import { unitStatusColors } from '../../../common/helpers/styles';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { observer } from 'mobx-react-lite';

export const StatusColorCell = observer(function StatusColorCell({
    value,
    tip,
    contentAlignment,
    data,
}: {
    value?: string;
    tip?: string;
    contentAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
    data: UnitQueueRowData;
}): React.ReactElement {
    const unitStatusColor = data.unitStateGroup ? unitStatusColors[data.unitStateGroup] : undefined;

    return (
        <Tooltip overlay={tip}>
            <BaseQueueCell
                alignment={contentAlignment}
                backgroundColor={unitStatusColor ? unitStatusColor.fill : ''}
                color={unitStatusColor ? unitStatusColor.text : ''}
                borderRadius="base"
                margin="half"
            >
                {value}
            </BaseQueueCell>
        </Tooltip>
    );
});
